import React from 'react';
import SignIn from "./sign-in/SignIn";

function Login({queryParams}) {
    return (
        <SignIn queryParams={queryParams}/>
    );
}

export default Login;
